// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"484":"3ec8408c","551":"a4220a1d"}[chunkId] + ".chunk.js";
};